module.exports = __webpack_public_path__ + "static/img/templateLogo.d0e8c84f.png";